import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Person, ServiceSelectionDto } from 'src/app/services/dtos';
import { ToastService } from '../services/toast.service';
import { HttpPersonService } from '../services/http-person.service';
import { catchError } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-preregistered-dialog',
	templateUrl: './preregistered-dialog.component.html',
	styleUrls: ['./preregistered-dialog.component.scss']
})
export class PreregisteredDialogComponent {

	@Input() capCode: string;
	@Output() confirmed = new EventEmitter<boolean>();

	inputCapCode: string;

	personList: Person[];
	person: Person;

	constructor(
		translate: TranslateService, 
		public activeModal: NgbActiveModal, 
		private toast: ToastService, 
		private httpPersonService: HttpPersonService,
		private spinner: NgxSpinnerService) { }

	onSearch() {
		console.log("CAP CODE: " + this.capCode + " - Searched for: " + this.inputCapCode);
		if (this.inputCapCode !== this.capCode) {
			this.toast.show('Invalid CAP code');
			// this.onCancel();
			return;
		}

		this.personList = undefined;
		
		this.spinner.show();
		this.httpPersonService.getPersonsByCapCode(this.inputCapCode)
				.pipe(
					catchError(error => {
						this.spinner.hide();
						console.log('Error', error);
						this.toast.show('Failed fetching Person data: ' + error.error.message);
						throw error;
					})
				)
				.subscribe(
					data => {
						this.spinner.hide();
						console.log('Got person data: ', data);
						if (data && data.length > 0) {
							this.personList = data
						} else {
							this.toast.show('No registered Militants exist under CAP Code:' + this.capCode);
						}
					}
				);
	}

	onConfirm() {
		this.activeModal.close(this.person);
	}

	// onCancel() {
	// 	this.activeModal.close(undefined);
	// }

}
